export default {"src":"/uk/_next/static/media/planInfoIcon.6a95001d.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};